import React from 'react';
import PersonalSite from './src/components/layout/PersonalSite.jsx';

function App() {
  return <PersonalSite />;
}

export default App;
